import { withModuleContext } from '@edreamsodigeo/frontend-core';
import { PrismaProvider } from '@edreamsodigeo/prisma-design-system';

import { MODULE_NAMESPACE } from 'utils/constants';

export const withAdditionalProductsContext = withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
